/**
 * Simple toast utility for user notifications
 * Uses alert as fallback when no proper toast system is available
 */

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export function showToast(message: string, type: ToastType = 'info'): void {
  console.log(`[Toast:${type.toUpperCase()}]`, message);
  
  if (typeof window !== 'undefined') {
    // Simple alert fallback - could be replaced with a proper toast library
    const prefix = {
      success: '✅',
      error: '❌',
      warning: '⚠️',
      info: 'ℹ️'
    }[type];
    
    window.alert(`${prefix} ${message}`);
  }
} 